
import { Component, Vue } from 'vue-property-decorator';
import { ValidationObserver } from 'vee-validate';

import TextField from '../../../../framework/fields/TextField.vue';
import SelectField from '../../../../framework/fields/SelectField.vue';

import { sharedState } from '../../../../framework/state';
import { postResource } from '../../../../framework/client/resource';
import { getEnumerationOptions } from '../../../../framework/service/options';

import { ApplicationResource } from '../../../../../common/application/enumeration/ApplicationResource';
import { VehicleMake } from '../../../../../common/application/model/VehicleMake';
import { VehicleMakeType } from '../../../../../common/application/model/enums/VehicleMakeType';

import { errorToast, successToast } from '../../../service/toast_service';

@Component({
    components: { SelectField, TextField, ValidationObserver },
})
export default class AddVehicleMake extends Vue {
    // Constants
    readonly resourceType = ApplicationResource.VEHICLE_MAKE;

    // Properties

    // State
    shared = sharedState;
    local = {
        row: {
            type: VehicleMakeType.CAR,
        } as VehicleMake,
        vehicleMakeTypeOptions: [] as { id: string | undefined; label: string }[],
    };

    // Functions
    async mounted() {
        this.local.vehicleMakeTypeOptions = getEnumerationOptions(
            'VehicleMakeType',
            Object.keys(VehicleMakeType),
            this,
        );
    }

    add() {
        this.addResource(false);
    }

    addAndClose() {
        this.addResource(true);
    }

    async addResource(goBack: boolean) {
        try {
            const newVehicleMake = await postResource<VehicleMake>(this.resourceType, this.local.row);
            successToast(this, 'message.vehicleMakeSaved');

            if (goBack) {
                this.back();
            } else {
                this.$router.replace(`/${this.resourceType}/${newVehicleMake.id}/edit`);
            }
        } catch (error) {
            errorToast(this);
        }
    }

    back() {
        this.$router.go(-1);
    }
}
